import { PageContentAnimation } from '../../../../components/layout';
import { CompanyUsersCard } from '../components/company-users/company-users-card.component';

export function CompanyUsersTab() {
  return (
    <PageContentAnimation>
      <CompanyUsersCard />
    </PageContentAnimation>
  );
}
